import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';

const addToTopCareersButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant ? props.tenant.primary : 'white',
    borderColor: props.tenant ? props.tenant.primary : 'black',

    '&:hover': {
      backgroundColor: 'white',
      border: props.tenant
        ? `2px solid ${props.tenant.primary}`
        : '2px solid black',
      color: props.tenant ? props.tenant.primary : 'black',
      borderStyle: 'solid',
    },
  }),
};

function AddToTopCareersButton(props) {
  const { t } = useTranslation();
  const dynamicButtonColor = props.classes.color;

  return (
    <div>
      <button
        className={['button--primary', dynamicButtonColor].join(' ')}
        style={{ minWidth: '215px', marginBottom: '25px' }}
        type="button"
        data-test-submit-top
        data-cy="add-top-careers-button"
        onClick={props.addCareer}
      >
        {t('Add to top careers')}
      </button>
    </div>
  );
}

export default withStyles(addToTopCareersButtonStyles)(AddToTopCareersButton);
